module.exports = __webpack_public_path__ + "static/media/29BDOS23.d847b6fd.jpg";